import React, { FC, useState } from 'react'
import { Flex } from '@chakra-ui/react'
import {
  Spinner,
  Switch,
  Input,
  DrawerItem,
  DrawerItemHeader,
  DrawerItemHint
} from 'front-end/src/components'
import { Trans, Plural } from '@lingui/macro'

import { TopicModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import IconClock from '../../../../components/common/icon/IconClock'
import { usePatchDraftMutation } from './operations/patchDraft.codegen'
import { useTopicForEditQuery } from 'front-end/src/pages/topic-edit-page/TopicEditPage'

export const SetDuration: FC<{}> = () => {
  const { data, loading, refetch: refetchTopic } = useTopicForEditQuery()
  const topic = data?.topic as TopicModelAsEditor
  const [patchDraft] = usePatchDraftMutation()
  const [showManuallyInput, setShowManuallyInput] = useState<boolean>(
    !!topic?.draftVersion?.manual_duration
  )
  const [manualDuration, setManualDuration] = useState<
    number | null | undefined
  >(topic?.draftVersion?.manual_duration)

  if (loading) {
    return <Spinner />
  }

  if (!topic?.draftVersion) {
    return null
  }

  const duration = Math.ceil(
    manualDuration
      ? manualDuration / 60
      : (topic.draftVersion.readDurationMins as number)
  )

  return (
    <DrawerItem>
      <Flex align="center" justify="space-between">
        <DrawerItemHeader dataTest="ReadTimeDrawer" mb={0}>
          <IconClock />
          <Trans>Set read time manually</Trans>
        </DrawerItemHeader>

        <Switch
          dataTest="ReadTimeSwitch"
          onChange={async () => {
            if (showManuallyInput) {
              await patchDraft({
                variables: {
                  topicId: topic.id,
                  input: {
                    manual_duration: null
                  }
                }
              })
              setManualDuration(null)
              refetchTopic()
            }
            setShowManuallyInput(!showManuallyInput)
          }}
          isChecked={showManuallyInput}
        />
      </Flex>

      <Flex justify="space-between" align="center" pt="8px">
        {!!topic.draftVersion.readDurationMins && (
          <DrawerItemHint>
            <Plural
              value={topic.draftVersion.readDurationMins}
              _0="Read time is < 1 min"
              one="Read time is 1 min"
              other="Read time is # mins"
            />
          </DrawerItemHint>
        )}

        {showManuallyInput && (
          <Flex align="center">
            <Input
              w="60px"
              textAlign="center"
              min={1}
              variant="filled"
              type="number"
              defaultValue={duration}
              data-test="ReadTimeInput"
              onChange={async (e) => {
                const value = Number(e.target.value)
                await patchDraft({
                  variables: {
                    topicId: topic.id,
                    input: {
                      manual_duration: value ? value * 60 : null // we want seconds on BE
                    }
                  }
                })
                setManualDuration(value)
                refetchTopic()
              }}
            />{' '}
            &nbsp;
            {!!manualDuration && (
              <Plural value={manualDuration} one="min" other="mins" />
            )}
          </Flex>
        )}
      </Flex>
    </DrawerItem>
  )
}
